export default __webpack_public_path__ + "static/media/mapMarker.4667f51a.svg";